import authReducer from './authReducer'
import gameReducer from './gameReducer'
import studygameReducer from './studygameReducer'
import apiReducer from './apiReducer'
import { combineReducers } from 'redux'
import { firestoreReducer } from 'redux-firestore'
import { firebaseReducer } from 'react-redux-firebase'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import hatsReducer from './hatsReducer'
import achievsReducer from './achievsReducer'

const apiPersistConfig = {
  key: 'apiCalls',
  storage: storage,
  whitelist: ['apiData']
}

const gamePersistConfig = {
  key: 'game',
  storage: storage,
  whitelist: ['currentNarrativeObject']
}

const rootReducer = combineReducers({
  auth: persistReducer({
    key: 'user',
    storage: storage,
  }, authReducer),
  game: persistReducer(gamePersistConfig, gameReducer),
  studyGame: studygameReducer,
  apiCalls: persistReducer(apiPersistConfig, apiReducer),
  hats: hatsReducer,
  achievements: achievsReducer,
  firestore: firestoreReducer,
  firebase: firebaseReducer
})

export default rootReducer;